export const UPDATE_BOOKING_FIELD = 'UPDATE_BOOKING_FIELD';

/* ----------------------- Update Booking Data -----------------------*/

export function updateBookingField({ jobId, id, data }) {
    return {
        type: 'UPDATE_BOOKING_FIELD',
        payload: { jobId, id, data },
    };
}
